import Link from "next/link";
import {getNavPath} from "../../shared/navigateUtil";
import {Col} from "react-bootstrap";
import React from "react";
import {IProductVariant} from "../../interfaces/IProductVariant";
import {useRouter} from "next/router";
// @ts-ignore
import ReactStars from "react-rating-stars-component";
import styled from "styled-components";
import {getTheme} from "../../shared/themeUtils";

const Contain = styled.div`
    .rating-variation {
        display: flex;
        align-items: center;

        span.rating-count {
            margin-left: ${getTheme("space.1")};
        }
    }
    .variant {
        cursor: pointer;
        border: 1px solid ${getTheme("colors.border")};
            //margin-bottom: ${getTheme("space.2")};
        height: 100%;
        padding: ${getTheme("space.1")};
        display: flex;
        align-items: center;
        font-size: ${getTheme("fontSizes.small")};

        &:hover {
            border-color: ${getTheme("colors.secondaryFont")};
        }

        .img-contain {
            width: 100px;
            display: flex;
            align-content: center;
            justify-content: center;

            img {
                max-width: 80px;
                max-height: 80px;
            }
        }

        .content {
            padding: 0 ${getTheme("space.1")};

            .price {
                font-weight: bold;
            }
        }
    }

    .selected-variant {
        border: 2px solid ${getTheme("colors.primary")};
    }
`

export default function ProductVariant({variant, selectedProductId}: {
  variant: IProductVariant,
  selectedProductId: number
}) {
  const router = useRouter()

  return (
    <Col xl={4} lg={6} md={12} key={variant.productId} className="mb-3">
      <Contain>
        <Link href={getNavPath(router, `p/${variant.slug}`)}>
          <div
            className={parseInt(variant.productId) == selectedProductId ? "selected-variant variant" : "variant"}>
            <div className="img-contain">
              <img src={variant.image} alt={variant.productName}/>
            </div>
            <div className="content">
              {variant.reviewScore > 0 &&
                <div className="rating-variation">
                  <ReactStars
                    count={5}
                    size={15}
                    activeColor="#ffd700"
                    edit={false}
                    isHalf={true}
                    value={variant.reviewScore}
                  />
                  <span
                    className={"text-muted rating-count"}>({variant.reviewsCount})</span>
                </div>}
              <div className="title">{variant.productName}</div>
              <div className="price">
                {variant.price}
              </div>
            </div>
          </div>
        </Link>
      </Contain>
    </Col>
  )
}